import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import _ from 'lodash'

import FormattedNumber from '../../../../../../../../../../components/FormattedNumber'
import { LOCALE_PREFIX } from '../../../Blocks/PaymentIndex/constants'

import './style.scss'

export default class PaymentBreakdown extends Component {
    static propTypes = {
        data: PropTypes.object,
    }

    renderBreakdownColumns = (data) => {
        const columnKeys = Object.keys(data?.paid?.intervals || {})

        return columnKeys.map((key, index) => (
            <div className={`column ${key}`} key={`column-${key}-${index}-${Math.random()}`}>
                <div className={'column-header'}>
                    <FormattedMessage id={`${LOCALE_PREFIX}.${key}`} />
                </div>
                <div className={'column-row'}>
                    <FormattedNumber
                        currency={data?.paid?.intervals?.[key]?.currency}
                        value={data?.paid?.intervals?.[key]?.amount}
                        customBase={1}
                        displayCurrency
                    />
                </div>
                <div className={'column-row'}>
                    <FormattedNumber
                        currency={data?.outstanding?.intervals?.[key]?.currency}
                        value={data?.outstanding?.intervals?.[key]?.amount}
                        customBase={1}
                        displayCurrency
                    />
                </div>
            </div>
        ))
    }

    render() {
        const { data } = this.props

        if (_.isEmpty(data)) return null

        return (
            <div className={'payment-morale-breakdown'}>
                <div className="title-container">
                    <FormattedMessage id={`${LOCALE_PREFIX}.paymentMoraleBreakdownTitle`} />
                </div>
                <div className={'year-index-breakdown-wrapper'}>
                    <div className={'index-title-container'}>
                        <FormattedMessage id={`${LOCALE_PREFIX}.yearPaymentIndex`} />
                    </div>
                    <div className={'breakdown'}>
                        <div className={'column breakdown-titles'}>
                            <div className={'column-header'}>
                                <FormattedMessage id={`${LOCALE_PREFIX}.invoices`} />
                            </div>
                            <div className={'column-row'}>
                                <FormattedMessage id={`${LOCALE_PREFIX}.paid`} />
                            </div>
                            <div className={'column-row'}>
                                <FormattedMessage id={`${LOCALE_PREFIX}.notPaid`} />
                            </div>
                        </div>
                        {this.renderBreakdownColumns(data?.year)}
                    </div>
                </div>
                <div className={'quarter-index-breakdown-wrapper'}>
                    <div className={'index-title-container'}>
                        <FormattedMessage id={`${LOCALE_PREFIX}.quarterPaymentIndex`} />
                    </div>
                    <div className={'breakdown'}>
                        <div className={'column breakdown-titles'}>
                            <div className={'column-header'}>
                                <FormattedMessage id={`${LOCALE_PREFIX}.invoices`} />
                            </div>
                            <div className={'column-row'}>
                                <FormattedMessage id={`${LOCALE_PREFIX}.paid`} />
                            </div>
                            <div className={'column-row'}>
                                <FormattedMessage id={`${LOCALE_PREFIX}.notPaid`} />
                            </div>
                        </div>
                        {this.renderBreakdownColumns(data?.quarter)}
                    </div>
                </div>
            </div>
        )
    }
}
